import { UsageV, BillingProfileV } from '@cb/types/entities/internal/billing';

import { read } from './generics';

export class Billing {
  public static readUsage = read(UsageV, 'billing/usage');
  public static readProfile = read(BillingProfileV, 'billing/profile');
}
